import React from "react";

import SelectableLabelsExpandable from "./SelectableLabelsExpandable";
import SelectableLabelsScrollable from "./SelectableLabelsScrollable";

import "./SelectableLabels.scss";

export function SelectableLabels({
  feed,
  setValue,
  translative,
  selectDensity,
  disabled,
  isDataFilterNameFromValue,
  getCustomLabel,
  isExpandable,
}) {
  if (isExpandable) {
    return (
      <SelectableLabelsExpandable
        feed={feed}
        setValue={setValue}
        translative={translative}
        selectDensity={selectDensity}
        disabled={disabled}
        isDataFilterNameFromValue={isDataFilterNameFromValue}
        getCustomLabel={getCustomLabel}
      />
    );
  } else {
    return (
      <SelectableLabelsScrollable
        feed={feed}
        setValue={setValue}
        translative={translative}
        selectDensity={selectDensity}
        disabled={disabled}
        isDataFilterNameFromValue={isDataFilterNameFromValue}
        getCustomLabel={getCustomLabel}
      />
    );
  }
}
